module.exports = __webpack_public_path__ + "static/media/hot-cat-banner-item-5.4d842d51.png";